<template>
  <div class="relative">
    <div class="relative">
      <div class="flex justify-between">
        <div>
          <span class="range-label bold-label">
            {{minLabel}}
          </span>
        </div>
        <div class="flex align-items-end justify-center relative upper">
          <span class="range-value mr-2 text-right">
            {{100 - localCompPercent}}%
          </span>
          <span class="vertical-separator"></span>
          <span class="range-value ml-2">
            {{localCompPercent}}%
          </span>
        </div>
        <div>
          <span class="range-label bold-label text-right">
            {{maxLabel}}
          </span>
        </div>
      </div>
      <div class="range">
        <b-form-input class="range__input"
          id="classPercent"
          v-model="localCompPercent"
          type="range"
          min="0"
          max="100"
          step="5"
          :disabled="componentDisabled || lock"
          @change="updateCompBlend">
        </b-form-input>
        <span class="range__fill" :style="{ width: `${localCompPercent}%` }"></span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';

export default {
  props: {
    data: Object,
    initial: String,
  },
  components: {},
  data() {
    return {
      debug: false,
      localCompPercent: ((Number(this.initial) * 100)).toString(),
      minLabel: this.data.minLabel,
      maxLabel: this.data.maxLabel,
    };
  },
  computed: {
    ...mapState(['compIns', 'availability', 'loading', 'insuranceBlend', 'compWeightingFactor']),
    ...mapGetters(['componentDisabled']),

    lock() {
      // This computed property is necessary only on the Component Insurance side because
      // the slider needs to be disabled if _either_ Comp Class III _or_ Comp Class IV are
      // unavailable
      const { componentClassIII, componentClassIV } = this.availability;
      return !componentClassIII || !componentClassIV;
    },
  },

  watch: {
    quarter(newValue) {
      if (newValue && !this.availability.componentClassIV && !this.lock) {
        this.localCompPercent = '0';
      }
      this.updateCompBlend();
      this.$forceUpdate();
    },
    availability(newValue) {
      if (this.debug) console.log(`availability(${newValue})`);
      if (!newValue.componentClassIII && newValue.componentClassIV) {
        this.localCompPercent = '100';
      }
      if (!newValue.componentClassIV && newValue.componentClassIII) {
        this.localCompPercent = '0';
      }
    },
    compWeightingFactor(newValue) {
      let { localCompPercent } = this;
      const newSliderValue = (Number(newValue) * 100).toString();
      if (this.debug) {
        console.log(`compWeightingFactor()
          New: ${newValue},
          Current: ${localCompPercent}
        `);
      }

      if (newSliderValue !== localCompPercent) {
        if (this.debug) {
          console.log(`localCompPercent => ${newSliderValue} from compWeightingFactor()`);
        }
        localCompPercent = newSliderValue;
        this.$forceUpdate();
      }
    },
  },

  methods: {
    ...mapMutations([
      'updateComponentPercent',
    ]),

    updateCompBlend() {
      const { localCompPercent } = this;
      if (this.debug) console.log(`updateCompBlend(${localCompPercent})`);
      this.$store.commit('updateComponentPercent', parseFloat(localCompPercent));
    },
  },
};
</script>

<style>
.upper {
  flex: 0 1 auto;
  margin: 0 auto;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 0;
  z-index: -1;
}

</style>
